import CustomBox from "../../../../../Components/UI/CustomBox/CustomBox/CustomBox";
import DetailButton from "../DetectionDetailPopup/DetailButton";
import useDetectionDetailPopup from "../DetectionDetailPopup/useDetectionDetailPopup";

import "./styles.scss";

const TopRiskyFiles = ({ files }) => {
  const { findFileDetail, openDetail, popup } = useDetectionDetailPopup();
  if (!files || files.length === 0) {
    return (
      <CustomBox className="thunter-top-risky-files">
        <h2 className="thunter-top-risky-files__title">Top Risky Files</h2>
        <p className="thunter-top-risky-files__empty">No risky files detected</p>
      </CustomBox>
    );
  }

  const getFileName = (filePath) => {
    if (!filePath) return "Unknown";
    const parts = filePath.split(/[\\/]/);
    return parts[parts.length - 1];
  };

  const getRiskLevel = (score) => {
    if (score > 30) return { text: "High", color: "#d32f2f" };
    if (score > 15) return { text: "Medium", color: "#f57c00" };
    return { text: "Low", color: "#388e3c" };
  };

  return (
    <CustomBox className="thunter-top-risky-files">
      <h2 className="thunter-top-risky-files__title">Top Risky Files</h2>

      <div className="thunter-top-risky-files__table">
        <div className="thunter-top-risky-files__head">
          <div className="thunter-top-risky-files__cell thunter-top-risky-files__cell--name">
            File Name
          </div>
          <div className="thunter-top-risky-files__cell thunter-top-risky-files__cell--path">
            Path
          </div>
          <div className="thunter-top-risky-files__cell thunter-top-risky-files__cell--score">
            Risk Score
          </div>
          <div className="thunter-top-risky-files__cell thunter-top-risky-files__cell--level">
            Risk Level
          </div>
        </div>

        <div className="thunter-top-risky-files__content">
          {files.map((file, index) => {
            const fileName = getFileName(file.file);
            const riskLevel = getRiskLevel(file.risk_score);
            const fileDetail = findFileDetail(file.file);

            return (
              <div className="thunter-top-risky-files__row" key={index}>
                <div
                  className="thunter-top-risky-files__cell thunter-top-risky-files__cell--name"
                  title={fileName}>
                  {fileName.length > 17 ? `${fileName.substring(0, 17)}...` : fileName}
                  {fileDetail ? (
                    <DetailButton
                      title="Show file details"
                      onClick={() => openDetail(fileDetail)}
                    />
                  ) : null}
                </div>
                <div
                  className="thunter-top-risky-files__cell thunter-top-risky-files__cell--path"
                  title={file.file}>
                  {file.file}
                </div>
                <div className="thunter-top-risky-files__cell thunter-top-risky-files__cell--score thunter-top-risky-files__cell--bold">
                  {file.risk_score.toFixed(1)}
                </div>
                <div
                  className="thunter-top-risky-files__cell thunter-top-risky-files__cell--level thunter-top-risky-files__cell--bold"
                  style={{ color: riskLevel.color }}>
                  {riskLevel.text}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {popup}
    </CustomBox>
  );
};

export default TopRiskyFiles;
